import type { ProSettings } from "@ant-design/pro-components";
import { Admin } from "services/admin/auth/types";
import { Lang } from "services/guest/reference/types";

export interface Settings extends Partial<ProSettings> {
  listen_socket: boolean;
}
export interface DataType {
  authorized: boolean;
  auth?: Admin;
  settings: Settings;
  references: References;
  langs: Lang[];
}

export enum Action {
  SIGN_OUT = "SIGN_OUT",
  SIGN_IN = "SIGN_IN",
  SET_SETTINGS = "SET_SETTINGS",
  SET_LANGS = "SET_LANGS",
  SET_REFERENCES = "SET_REFERENCES",
}

export type ReducerType = (state: DataType, action: Actions) => DataType;

export type Actions =
  | [Action.SIGN_OUT]
  | [Action.SIGN_IN, Admin]
  | [Action.SET_LANGS, Lang[]]
  | [Action.SET_SETTINGS, Settings]
  | [Action.SET_REFERENCES, References];

export type Refreshs = {
  info: () => void;
};
export type Type = [DataType, (action: Actions) => void, Refreshs];

export interface References {
  loading: boolean;
}

export interface CabinClass {
  name: string;
  value: string;
}

export interface PassengerType {
  name: string;
  value: string;
}
